module.exports = __webpack_public_path__ + "static/media/react-js.a03a8833.svg";